import GridEmblem from "../GridEmblem.tsx";
import { hero, heroActions, heroEmblem, heroEmblemSmall, lede, ledeLarge } from "../../lib/ui.ts";
import { Band } from "./Band.tsx";
import { Eyebrow } from "./Eyebrow.tsx";
import { Wrap } from "./Wrap.tsx";

type Emblem = "default" | "small" | "none";

export function Hero({
  eyebrow,
  eyebrowClassName,
  title,
  lede: ledeProp,
  ledeLarge: isLarge,
  actions,
  emblem = "none",
  media,
  largeTitle,
}: {
  eyebrow?: React.ReactNode;
  eyebrowClassName?: string;
  title?: React.ReactNode;
  lede?: React.ReactNode;
  ledeLarge?: boolean;
  actions?: React.ReactNode;
  emblem?: Emblem;
  /**
   * Anything that should sit in the hero's second column instead of the
   * emblem — in practice a book's cover. Takes precedence over `emblem`,
   * because a page that has the real object has no use for the ornament.
   */
  media?: React.ReactNode;
  largeTitle?: boolean;
}) {
  const emblemClass = emblem === "small" ? heroEmblemSmall : heroEmblem;
  const aside = media ?? (emblem === "none" ? null : <GridEmblem className={emblemClass} />);
  const ledeClass = isLarge ? ledeLarge : lede;

  const titleNode =
    title == null ? null : largeTitle ? (
      <h1 className="font-display font-bold leading-[1.03] text-[clamp(2.5rem,8vw,4.2rem)] tracking-[-0.01em] mb-[0.45em]">
        {title}
      </h1>
    ) : (
      <h1 className="font-display font-bold text-[clamp(2.1rem,6vw,3.1rem)] leading-[1.15] tracking-[-0.01em] m-0 mb-[0.4em]">
        {title}
      </h1>
    );

  return (
    <Band variant="hero">
      <Wrap className={aside ? hero : undefined}>
        <div>
          {eyebrow != null ? <Eyebrow className={eyebrowClassName}>{eyebrow}</Eyebrow> : null}
          {titleNode}
          {ledeProp != null ? <p className={ledeClass}>{ledeProp}</p> : null}
          {actions ? <div className={heroActions}>{actions}</div> : null}
        </div>
        {aside}
      </Wrap>
    </Band>
  );
}
